import React, { useEffect } from 'react';

import { ueepci_item } from '../../json/ueepci';

import './ueepci.css';

const UEEPCI = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="ueepci-page">
      <div className="ueepci-container">

        <header className="ueepci-header">
          <h1>
            Unidad Especializada de Ética y de Prevención de Conflictos de Interés
          </h1>

          <div className="ueepci-title-line">
            <span></span>
          </div>

          <p>
            Consulta los informes, documentos y materiales disponibles de la
            Unidad Especializada de Ética y de Prevención de Conflictos de Interés.
          </p>
        </header>

        <section className="ueepci-grid">
          {ueepci_item.map((item, index) => (
            <a
              key={index}
              href={item.url ? item.url : `DetalleRubros/${item.nombre}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ueepci-card"
            >
              <div
                className={`ueepci-icon ${
                  index % 2 === 0
                    ? 'ueepci-icon-wine'
                    : 'ueepci-icon-gold'
                }`}
              >
                <img
                  src={`http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/${item.icono}`}
                  alt=""
                />
              </div>

              <h3>{item.nombre}</h3>

              <p>
                Consulta la información y documentación correspondiente.
              </p>

              <div className="ueepci-card-link">
                <span>Ver documento</span>

                <i className="fa-solid fa-arrow-right"></i>
              </div>
            </a>
          ))}
        </section>

      </div>
    </main>
  );
};

export default UEEPCI;